export default "__VITE_ASSET__BABuU4l4__"